/**
 * Keeps an unfinished assessment on the owner's device so a phone call,
 * lock screen or page reload does not lose their work. Photos are not kept
 * (they are too large for browser storage); the draft remembers which
 * defects had one so the owner can be reminded to re-attach them.
 *
 * Storage can be unavailable (private mode, blocked site data), so every
 * access is wrapped and failures are ignored.
 */
const PREFIX = 'squared:assessment-draft:';

function keyFor(houseSlug) {
    return PREFIX + houseSlug;
}

export function loadDraft(houseSlug) {
    if (!houseSlug) {
        return null;
    }
    try {
        const raw = window.localStorage.getItem(keyFor(houseSlug));
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

export function saveDraft(houseSlug, draft) {
    if (!houseSlug) {
        return;
    }
    try {
        window.localStorage.setItem(keyFor(houseSlug), JSON.stringify(Object.assign({}, draft, { savedAt: Date.now() })));
    } catch (e) {
        // Storage full or unavailable; the wizard still works without a draft.
    }
}

export function clearDraft(houseSlug) {
    if (!houseSlug) {
        return;
    }
    try {
        window.localStorage.removeItem(keyFor(houseSlug));
    } catch (e) {
        // Ignore.
    }
}

/**
 * A short human description of where the draft is up to, e.g. "Main Bedroom › Wall".
 */
export function describeDraft(draft) {
    if (!draft) {
        return '';
    }
    return [draft.label_house_area, draft.label_house_component].filter(Boolean).join(' › ') || 'New inspection';
}
